export default "__VITE_ASSET__AZhCyDoA__"